import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["matters"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      filevineSyncActionUpdateFilename: build.mutation<
        FilevineSyncActionUpdateFilenameApiResponse,
        FilevineSyncActionUpdateFilenameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine-sync/actions/${queryArg.actionId}/filename/`,
          method: "PATCH",
          body: queryArg.patchedUpdateActionFilenameSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      filevineSyncActionUpdateStatus: build.mutation<
        FilevineSyncActionUpdateStatusApiResponse,
        FilevineSyncActionUpdateStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine-sync/actions/${queryArg.actionId}/status/`,
          method: "PATCH",
          body: queryArg.patchedUpdateActionStatusSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      filevineSyncPlansList: build.query<
        FilevineSyncPlansListApiResponse,
        FilevineSyncPlansListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine/sync/plans/`,
        }),
        providesTags: ["matters"],
      }),
      filevineIngestionStatus: build.query<
        FilevineIngestionStatusApiResponse,
        FilevineIngestionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine/sync/plans/ingestion-status/`,
        }),
        providesTags: ["matters"],
      }),
      filevineSyncPlansTrigger: build.mutation<
        FilevineSyncPlansTriggerApiResponse,
        FilevineSyncPlansTriggerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine/sync/plans/trigger/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      filevineIngestionTrigger: build.mutation<
        FilevineIngestionTriggerApiResponse,
        FilevineIngestionTriggerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/filevine/sync/plans/trigger-ingestion/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      cmsGuessCmsSystem: build.query<
        CmsGuessCmsSystemApiResponse,
        CmsGuessCmsSystemApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/cms/guess/`,
        }),
        providesTags: ["matters"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type FilevineSyncActionUpdateFilenameApiResponse =
  /** status 200  */ RootModelAnnotatedUnionFilevineCreateBlobActionSchemaFilevineCreateFilevineDocumentActionSchemaFilevineCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType;
export type FilevineSyncActionUpdateFilenameApiArg = {
  actionId: string;
  matterId: string;
  patchedUpdateActionFilenameSchema: UpdateActionFilenameSchema;
};
export type FilevineSyncActionUpdateStatusApiResponse =
  /** status 200  */ RootModelAnnotatedUnionFilevineCreateBlobActionSchemaFilevineCreateFilevineDocumentActionSchemaFilevineCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType;
export type FilevineSyncActionUpdateStatusApiArg = {
  actionId: string;
  matterId: string;
  patchedUpdateActionStatusSchema: UpdateActionStatusSchema;
};
export type FilevineSyncPlansListApiResponse =
  /** status 200  */ FilevineSyncPlanListSchema[];
export type FilevineSyncPlansListApiArg = {
  matterId: string;
};
export type FilevineIngestionStatusApiResponse =
  /** status 200  */ FilevineIngestionSchema;
export type FilevineIngestionStatusApiArg = {
  matterId: string;
};
export type FilevineSyncPlansTriggerApiResponse = /** status 202  */ {
  workflow_id?: string;
};
export type FilevineSyncPlansTriggerApiArg = {
  matterId: string;
};
export type FilevineIngestionTriggerApiResponse = /** status 202  */ {
  workflow_id?: string;
};
export type FilevineIngestionTriggerApiArg = {
  matterId: string;
};
export type CmsGuessCmsSystemApiResponse =
  /** status 200  */ GuessCmsSystemResponse;
export type CmsGuessCmsSystemApiArg = {
  matterId: string;
};
export type FilevineSyncActionStatus =
  | "PENDING"
  | "AWAITING_APPROVAL"
  | "APPROVED"
  | "REJECTED"
  | "EXECUTING"
  | "COMPLETED"
  | "FAILED";
export type FilevineSyncApprovalTypes = "AUTO_APPROVE" | "MANUAL_APPROVE";
export type FilevineCreateBlobActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: FilevineSyncActionStatus;
  approval_type: FilevineSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_BLOB";
  filevine_document_id: string | string;
  file_name: string;
};
export type FilevineCreateFilevineDocumentActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: FilevineSyncActionStatus;
  approval_type: FilevineSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_FILEVINE_DOCUMENT";
  blob_id: string | string;
  file_name: string;
  suggested_name: string;
};
export type FilevineCreateNoteActionSchema = {
  id: string | string;
  plan_id: string | string;
  status: FilevineSyncActionStatus;
  approval_type: FilevineSyncApprovalTypes;
  approved_by_id: (string | string) | null;
  approved_at: string | null;
  executed_at: string | null;
  completed_at: string | null;
  error_message: string | null;
  created_at: string;
  modified_at: string;
  action_type?: "CREATE_NOTE";
  event_update_item_id: string | string;
  task_update_id?: (string | string) | null;
  staff_note_id?: (string | string) | null;
  subject?: string | null;
  body: string;
};
export type RootModelAnnotatedUnionFilevineCreateBlobActionSchemaFilevineCreateFilevineDocumentActionSchemaFilevineCreateNoteActionSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorActionType =

    | ({
        action_type: "CREATE_BLOB";
      } & FilevineCreateBlobActionSchema)
    | ({
        action_type: "CREATE_FILEVINE_DOCUMENT";
      } & FilevineCreateFilevineDocumentActionSchema)
    | ({
        action_type: "CREATE_NOTE";
      } & FilevineCreateNoteActionSchema);
export type UpdateActionFilenameSchema = {
  /** New filename to use when creating the document in Filevine */
  file_name: string;
};
export type UpdateActionStatusSchema = {
  /** New status for the action. Must be a valid transition from current status. */
  status: FilevineSyncActionStatus;
};
export type FilevineSyncPlanListSchema = {
  id: string | string;
  matter_id: string | string;
  workflow_id: string;
  status: string;
  failure_reason: string | null;
  actions?: (
    | ({
        action_type: "CREATE_BLOB";
      } & FilevineCreateBlobActionSchema)
    | ({
        action_type: "CREATE_FILEVINE_DOCUMENT";
      } & FilevineCreateFilevineDocumentActionSchema)
    | ({
        action_type: "CREATE_NOTE";
      } & FilevineCreateNoteActionSchema)
  )[];
  created_at: string;
  modified_at: string;
};
export type FilevineIngestionStatus = "IN_PROGRESS" | "COMPLETED" | "FAILED";
export type FilevineIngestionStatsSchema = {
  total_documents_synced?: number;
  total_documents_created?: number;
  total_documents_updated?: number;
  total_documents_deleted?: number;
  total_errors?: number;
};
export type FilevineIngestionSchema = {
  id: string | string;
  matter_id: string | string;
  workflow_id: string;
  status: FilevineIngestionStatus;
  current_phase?: string | null;
  started_at: string;
  completed_at?: string | null;
  failure_reason?: string | null;
  stats?: FilevineIngestionStatsSchema;
};
export type CmsSystem =
  | "CASEpeer"
  | "Filevine"
  | "Litify"
  | "MyCase"
  | "Clio Manage"
  | "SmartAdvocate"
  | "PracticePanther"
  | "Needles"
  | "Neos"
  | "Merus"
  | "TrialWorks";
export type GuessCmsSystemResponse = {
  matter_id: string | string;
  cms_system: CmsSystem;
  external_cms_url: string | null;
};
export const {
  useFilevineSyncActionUpdateFilenameMutation,
  useFilevineSyncActionUpdateStatusMutation,
  useFilevineSyncPlansListQuery,
  useFilevineIngestionStatusQuery,
  useFilevineSyncPlansTriggerMutation,
  useFilevineIngestionTriggerMutation,
  useCmsGuessCmsSystemQuery,
} = injectedRtkApi;
